// 🔔 알림톡 공용 유틸 (가격안내 개별 품목 발송)
// - 관리자 화면 3곳에서 공통으로 사용

export interface SendPriceNoticeResult {
  success: boolean;
  sent: number;
  skipped: number;
  results: Array<{ device_id: string; success: boolean; message: string; skipped?: boolean }>;
}

const API_BASE_URL = (import.meta as any).env?.VITE_API_BASE_URL || 'https://api-4iuywcitfq-uc.a.run.app';

/**
 * 가격안내 상태에서만 각 기기별 알림톡 발송
 * 멱등성(중복 전송 차단)을 기본 적용, 필요시 force로 재전송
 */
export async function sendAlimtalkPriceNotice(applicationId: string, force: boolean = false, deviceIds?: string[]): Promise<SendPriceNoticeResult> {
  const res = await fetch(`${API_BASE_URL}/api/alerts/send-price-per-device/${applicationId}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ force, device_ids: deviceIds })
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.message || data.error || `HTTP ${res.status}`);
  }
  return res.json();
}


